import React from 'react';
import TemplateHeader from "./template-header.jsx";
import TemplateTitle from "./template-title.jsx";
import TemplateBody from "./template-body.jsx";
import Loader from "./loader.jsx";

const _Template = ({children, isLoading, className = ""}) => {
    return (
        <div className={[className, "bg-[#f3f3f4]"].join(" ")}>
            {isLoading && <Loader/>}

            <div className={"flex flex-col min-h-screen"}>
                {children}
            </div>
        </div>
    );
};

export const Template = Object.assign(_Template, {
    Header: TemplateHeader,
    Title: TemplateTitle,
    Body: TemplateBody
});